import { graphql } from '@/generated/gql';

export const NEGOTIATION_TERMS_UPDATE_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiationTermsUpdate(
    $id: UUID!
    $strategy: TsrctNegotiationStrategyBoundariesInput!
    $options: TsrctNegotiationCaseOptionsInput!
  ) {
    tesseract {
      negotiationCase(id: $id) {
        strategy {
          update(data: $strategy) {
            id
            useHistoricTenderData
            useHistoricNegotiationData
            boundaryRules {
              id
              base
              lower
              upper
              sequence
            }
          }
        }
        options {
          update(data: $options) {
            id
            initiatedBy
            quoteMode
            negotiationMode
            supplierInteractionMode
            negotiationObjective
          }
        }
      }
    }
  }
`);
